'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M32 160C32 89.3 89.3 32 160 32S288 89.3 288 160c0 44.2-23 87.2-64 110.9l-72 41.6-8 4.6 0 83 32 0 0-64.5 64-37c51.3-29.6 79.9-83.4 80-138.5l0 0C320 71.6 248.4 0 160 0S0 71.6 0 160l0 16 32 0 0-16zM180 512l0-40-40 0 0 40 40 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;